<div class="item-panel">
	<div class="heading clickable" [routerLink]="['asset', asset.asset_id]">
		<b>{{ asset.alt_asset_term || brand.assetSingular}}</b> - {{asset.asset_name}}
		<span *ngIf="asset.asset_serial_number"> ({{asset.asset_serial_number}})</span><span *ngIf="asset.fleet_id === 0"> - {{asset.organization_name}}</span>
	</div>
	<div class="content dark">
		<div class="row justify-content-between">
			<div class="col-sm clickable" [routerLink]="['asset', asset.asset_id]">
				<div><b>{{asset.alt_asset_term || brand.assetSingular}} Type:</b> {{asset.asset_type_name | removeBaseline}}</div>
				<div *ngIf="!asset.is_fixed && asset.flight_time !== null"><b>{{brand.flightTime}}:</b> {{asset.flight_time | runtime}}</div>
				<div *ngIf="asset.rulmin"><b>RUL:</b> {{asset.rulmin | number : "1.2-2"}} hours</div>
				<div *ngIf="asset.last_operation_date && !asset.is_fixed" title="{{asset.last_operation_date | datetime}}">
					<b>Last operation:</b>
					{{asset.last_operation_date | datetime : 'offsetshort' : time_offset_hours}}
				</div>
			</div>
			<div class="col-sm-auto">
				<app-health-split-asset [asset]="asset"></app-health-split-asset>
			</div>
		</div>
	</div>
</div>